module.exports = __webpack_public_path__ + "static/media/chevron-right-white.fe63d721.svg";